export default {
  cashflowAccountsManagement: '/cashflow/accounts-management',
  fabrickSuccess: '/cashflow/fabrick/success',
  fabrickError: '/cashflow/fabrick/error',
  tagManagement: '/cashflow/tag-management',
  cardOnboardingResult: '/card-onboarding/result'
}